<template>
  <div>
    <data-table
      :items="items"
      v-on:updateData="getInvoices"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >
      <template v-slot:headings>
        <div class="col-md-1">Invoice</div>
        <div class="col-md-2">Created</div>

        <div class="col-md-4">Job</div>
        <div class="col-md-2">Amount</div>
        <div class="col-md-1">Status</div>
        <div class="col-md-2 text-left text-md-right">Action</div>
      </template>

      <template v-slot:rows="slotProps">
        <div class="col-md-1 my-auto">
          <p class="m-0">{{ slotProps.item.invoice_number }}</p>
        </div>

        <div class="col-md-2 my-auto">
          {{
            moment(new Date(slotProps.item.created_at)).format(
              "DD MMM YY, HH:mm"
            )
          }}
        </div>

        <div class="col-md-4 my-auto">
          <p class="m-0" v-if="slotProps.item.job">
            #{{ slotProps.item.job.job_number }}
            <i
              class="lni lni-search-alt pointer text-info"
              @click="
                selectedJob = slotProps.item.job_id;
                jobShow = true;
              "
            ></i>
            {{ slotProps.item.job.outcome }}
          </p>
        </div>

        <div class="col-md-2 my-auto">
          <p class="m-0 text-primary">{{ slotProps.item.total_amount | currency }}</p>
        </div>

        <div class="col-md-1 my-auto">
          <b-badge variant="success" v-if="slotProps.item.is_paid == 1"
            >paid</b-badge
          >
          <b-badge variant="warning" v-if="slotProps.item.is_paid == 0"
            >unpaid</b-badge
          >
        </div>

        <div class="col-md-2 my-auto text-left text-md-right pt-3 pt-md-0">
          <i
            v-if="slotProps.item.is_paid == 0"
            title="Mark as Paid"
            class="lni lni-coin pointer text-success mr-3"
            @click="markPaid(slotProps.item.id)"
          ></i>

          <i
            v-if="slotProps.item.is_paid == 1"
            title="Mark as UnPaid"
            class="lni lni-coin pointer text-danger mr-3"
            @click="markUnpaid(slotProps.item.id)"
          ></i>

          <i
            class="lni lni-search-alt pointer text-primary mr-3"
            @click="
              selectedInvoice = slotProps.item;
              invoiceShow = true;
            "
          ></i>

           <i
            v-if="slotProps.item.job"
            title="print invoice"
            class="lni lni-printer pointer text-info"
            @click="printInvoice(slotProps.item.job,slotProps.item.uid)"
          ></i>

          <i
          v-if="!slotProps.item.job"
          title="print invoice"
          class="lni lni-printer pointer text-info"
          @click="printAdHocInvoice(slotProps.item)"
        ></i>
        </div>
      </template>
    </data-table>

    <b-modal
      :hide-footer="true"
      title="Job Details"
      size="xl"
      v-model="jobShow"
      :no-close-on-route-change="true"
      :lazy="true"
    >
      <job :id="selectedJob"></job>
    </b-modal>

    <b-modal
      :hide-footer="true"
      title="Invoice Details"
      size="xl"
      v-model="invoiceShow"
      :no-close-on-route-change="true"
      :lazy="true"
    >
      <table class="table table-sm border" v-if="selectedInvoice">
        <tr>
          <td width="20%" class="bg-primary text-white">CODE</td>
          <td width="36%" class="bg-primary text-white">DESCRIPTION</td>
          <td width="8%" class="bg-primary text-white">QUANITY</td>
          <td width="18%" class="bg-primary text-white text-right">AMOUNT</td>
          <td width="18%" class="bg-primary text-white text-right">TOTAL</td>
        </tr>

        <tr v-for="line in selectedInvoice.invoice_items" :key="line.id">
          <td>
            {{ line.code }}
          </td>
          <td>
            {{ line.description }}
          </td>
          <td>
            {{ line.quantity }}
          </td>
          <td class="text-right">
            <strong> {{ line.line_amount }}</strong>
          </td>
          <td class="text-right">
            <strong> {{ line.line_total_amount }}</strong>
          </td>
        </tr>

        <tr>
          <td class="border-0"></td>
          <td class="border-0"></td>
          <td class="border-0"></td>
          <td class="border-0"></td>
          <td class="border-0"></td>
        </tr>

        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td class="text-right">SUB TOTAL</td>
          <td class="text-right">
            <strong> {{ selectedInvoice.sub_total_amount }}</strong>
          </td>
        </tr>

        <tr>
          <td></td>
          <td></td>
            <td></td>
          <td class="text-right">DISCOUNT</td>
          <td class="text-right">
            <strong> {{ selectedInvoice.discount_amount }}</strong>
          </td>
        </tr>

        <tr v-if="selectedInvoice.vat_amount">
          <td></td>
          <td></td>
            <td></td>
          <td class="text-right">VAT</td>
          <td class="text-right">
            <strong>{{ selectedInvoice.vat_amount }} </strong>
          </td>
        </tr>

        <tr>
          <td colspan="3" class="bg-light"></td>
          <td class="text-right bg-light lead">
            <strong>TOTAL DUE</strong>
          </td>
          <td class="text-right bg-light lead">
            <strong>{{ selectedInvoice.total_amount }}</strong>
          </td>
        </tr>
      </table>
    </b-modal>
  </div>
</template>

<script>
import accountRepo from "@/api/repos/accountRepo";
import dataTable from "@/components/common/DataTable";
import job from "@/views/modules/jobs/enquiryDetailed";

export default {
  props: ["accountId"],

  components: {
    job,
    dataTable,
  },

  data() {
    return {
      jobShow: false,
      selectedJob: null,
      invoiceShow: false,
      selectedInvoice: null,
      sidebarToggle: false,
      isLoad: false,
      sort: { column: "created_at", label: "Latest", order: "desc" },
      sortOptions: [
        { column: "created_at", label: "Oldest", order: "asc" },
        { column: "created_at", label: "Latest", order: "desc" },
      ],
      filterOptions: [],
      page: 1,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 10,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: [],
    };
  },
  mounted() {
    this.getInvoices({
      sort: this.sort,
      filters: null,
      page: this.page,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 10,
      search: "",
    });
  },
  methods: {
    async getInvoices(e) {
      this.isLoad = true;
      try {
        let { data } = await accountRepo.accountInvoices(
          this.accountId,
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.search,
          e.filters != null ? e.filters : null
        );

        this.items = data.invoices.data;
        this.totalRows = data.invoices.total;
        this.page = data.invoices.current_page;
        this.fromRow = data.invoices.from;
        this.toRow = data.invoices.to;
        this.lastPage = data.invoices.last_page;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },
    async markPaid(id) {
      this.items.forEach((i) => {
        if (i.id == id) {
          i.is_paid = 1;
        }
      });
      try {
        await accountRepo.invoicePaid(id);
      } catch (error) {
        console.log(error);
        this.$root.$bvToast.toast("Something went wrong", {
          title: "Whoops",
          autoHideDelay: 3000,
          variant: "danger",
        });
        this.items.forEach((i) => {
          if (i.id == id) {
            i.is_paid = 0;
          }
        });
      }
    },
    async markUnpaid(id) {
      this.items.forEach((i) => {
        if (i.id == id) {
          i.is_paid = 0;
        }
      });
      try {
        await accountRepo.invoiceUnpaid(id);
      } catch (error) {
        console.log(error);
        this.$root.$bvToast.toast("Something went wrong", {
          title: "Whoops",
          autoHideDelay: 3000,
          variant: "danger",
        });
        this.items.forEach((i) => {
          if (i.id == id) {
            i.is_paid = 1;
          }
        });
      }
    },
     printInvoice(job,uid){
     window.open(`/pdf/reports/job/${job.uid}/invoice/${uid}?cid=${job.company_id}`)
    },
    printAdHocInvoice(invoice){
     window.open(`/pdf/reports/invoice/${invoice.uid}?cid=${invoice.company_id}`)
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.sidebarToggle = newVal.meta && newVal.meta.sidebarToggle;
      },
    },
  },
};
</script>
